import { useEffect, useState } from 'react';

/**
 * Тикающий «текущий момент» в мс для живых обратных отсчётов (таймер активности ящика mm:ss).
 * Перерисовывает потребителя каждые `intervalMs` (по умолчанию 1 с).
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => { setNow(Date.now()); }, intervalMs);
    return () => { clearInterval(id); };
  }, [intervalMs]);
  return now;
}
